<template>
    <div class="panel-body">
        <div v-for="group in channel.items" :key="group.groupingName">
            <div class="row">
                <div class="col-md-12 clearfix">
                    <h3>{{group.groupingName}}</h3>
                </div>
            </div>
            <input-loader :fields="group.groupItems"></input-loader>
        </div>

        <div class="form-group row">
            <div class="col-md-9 ml-auto text-right">
                <button v-on:click="saveShopify()" type="button" class="btn btn-primary">Save</button>
                <a :href="baseUrl+ '/channels'" class="btn btn-secondary">
                    Cancel
                </a>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host;
    import InputLoader from "../form/form-loader.vue";
    import getNestedProperty from "../../mixins/getNestedProperty.js";
    import addCommonSettings from "./common-settings.js";

    export default {
        name: "shopify-specific",
        components: {
            "input-loader": InputLoader,
        },
        mixins: [getNestedProperty, addCommonSettings],
        props: ['channelvalues', 'channeloptions'],
        data() {
            return {
                channel: {
                    items: [],
                },
                alert: {
                    message: "",
                    status: "alert-success",
                    timeOut: 15000,
                },
                baseUrl: base_url,
                canSeeAdminFields: dataObject.canSeeAdminFields,
                postURL: base_url + "/channels/" + dataObject.channel.id,
                loading: false
            };
        },
        methods: {
            saveShopify: function () {
                this.loading = true;
                this.$emit("channel-specific-save", this.channel);
            },
            setItems: function () {
                var cvs = this.channelvalues;
                var cfo = this.channeloptions;

                this.channel.items = [
                    {
                        groupingName : "Settings",
                        groupItems : [
                            {
                                name : "product_json_warranty",
                                label : "Push json product into metafields",
                                required : false,
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'product_json_warranty')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Include the product description as json in the metafields'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - The product description will not be included in the metafields'
                                    }
                                ],
                                tooltip: 'Include the warranty as json in the product description ',
                                tooltip_position: 'top'
                            },
                            {
                                name : "product_json_version",
                                label : "Push json product versions into metafields",
                                required : false,
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'product_json_version')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Include the product description versioned as json in the metafields'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - The product description versioned will not be included in the metafields'
                                    }
                                ],
                                tooltip: 'This feature stores the json versions into metafields',
                                tooltip_position: 'top',
                                hide: !cfo.product_json_version_metafield
                            },
                            {
                                name : "product_json_metafield_in_variant",
                                label : "Push product json metafield into variants",
                                required : false,
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'product_json_metafield_in_variant')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Include the product json metafield in the variants'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - The product json metafield will not be included in the variants'
                                    }
                                ],
                                tooltip: 'Include product json metafield in the variants',
                                tooltip_position: 'top'
                            },
                            {
                                name: 'category_json',
                                label: 'Push json category into metafields',
                                required: false,
                                type: 'select',
                                column: 'col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end',
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'category_json')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Include the category as json in the metafields'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - The category will not be included in the metafields'
                                    }
                                ],
                                tooltip: 'Include the category as json in the metafields',
                                tooltip_position: 'top-no-label'
                            },
                            {
                                name: 'category_json_versioned',
                                label: 'Push versioned category json into metafields',
                                required: false,
                                type: 'select',
                                column: 'col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end',
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'category_json_versioned')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Include category versions as json in the metafields'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : "Disabled - The category versions won't be included in the metafields"
                                    }
                                ],
                                tooltip: 'Include the versioned category json in the metafields',
                                tooltip_position: 'top-no-label'
                            },
                            {
                                name : "parent_categories",
                                label : "Push Parent Categories",
                                required : false,
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'parent_categories')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Push the parent categories of the products synced'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Parent categories will not be pushed to the store'
                                    }
                                ],
                                tooltip: 'Push parent categories of the products synced',
                                tooltip_position: 'top'
                            },
                            {
                                name : "shopify_metafields_namespace",
                                label : "Metafields Namespace",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                maxlength : "20",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'shopify_metafields_namespace')) ? cvs.json_options.configuration.shopify_metafields_namespace  : "",
                                tooltip: 'Use this as the Shopify namespace otherwise use default "jasper"',
                                tooltip_position: 'top'
                            },
                            {
                                name : "hide_disabled",
                                label : "Hide Disabled Products",
                                required : false,
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'hide_disabled')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Hide all the products that are not enabled on the store on a sync'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Delete disabled products from the store on a sync'
                                    }
                                ],
                                tooltip: 'Turning this on will hide all the products that are not enabled on the store on a sync',
                                tooltip_position: 'top-no-label'
                            },
                            {
                                name : "inherit_tags_master",
                                label : "Inherit Product Tags From Master",
                                required : false,
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'inherit_tags_master')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Include tags from previous version or master in the set of available tags'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Do not include tags from previous versions or master'
                                    }
                                ],
                                tooltip: 'Include tags from previous version or master in the set of available tags',
                                tooltip_position: 'top'
                            },
                            {
                                name : "import_skip_new_products_from_versions",
                                label : "Import - Skip products from version stores that doesn't exist on master",
                                required : false,
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'import_skip_new_products_from_versions')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Skip new products from version stores'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Import new products from version stores'
                                    }
                                ],
                                tooltip: 'Skip new products from version stores if this is enabled',
                                tooltip_position: 'top'
                            },
                            {
                                name : "disable_price_sync",
                                label : "Price Sync",
                                required : false,
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'disable_price_sync')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'false',
                                        'name' : 'Enabled - Price Sync is ON'
                                    },
                                    {
                                        'id' : 'true',
                                        'name' : 'Disabled - Price Sync is OFF'
                                    }
                                ],
                                tooltip: 'Do not update prices on sync',
                                tooltip_position: 'top-no-label'
                            },
                            {
                                name : "default_weight_unit",
                                label : "Default Weight Unit",
                                required : false,
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'default_weight_unit')) ? cvs.json_options.configuration.default_weight_unit  : "",
                                options : [
                                    {
                                        "id" : "g",
                                        "name" : "g"
                                    },
                                    {
                                        "id" : "kg",
                                        "name" : "kg"
                                    },
                                    {
                                        "id" : "oz",
                                        "name" : "oz"
                                    },
                                    {
                                        "id" : "lb",
                                        "name" : "lb"
                                    }
                                ],
                                tooltip: 'Unit for default weight',
                                tooltip_position: 'top'
                            },
                            {
                                name : "enabled_shopify_channels",
                                label : "Product Channels Enabled",
                                type : "multiselect",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'enabled_shopify_channels')) ? cvs.json_options.configuration.enabled_shopify_channels  : "",
                                options : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'available_shopify_channels')) ? cvs.json_options.configuration.available_shopify_channels  : [],
                                tooltip: 'List of Shopify channels that are enabled',
                                tooltip_position: 'top'
                            },
                            {
                                name : "price_list_countries",
                                label : "Price List Countries",
                                type : "multiselect",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'price_list_countries')) ? cvs.json_options.configuration.price_list_countries  : "",
                                options : (cfo.countries) ? cfo.countries : [],
                                tooltip: 'Countries that allow updates using Price Lists',
                                tooltip_position: 'top'
                            },
                            {
                                name : "use_inventory_location_list",
                                label : "Use Inventory Locations",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'use_inventory_location_list')) ? cvs.json_options.configuration.use_inventory_location_list  : "",
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Allow Shopify locations configuration for Inventory sync'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Use default inventory sync rules'
                                    }
                                ],
                                tooltip: 'Use inventory locations',
                                tooltip_position: 'top'
                            },
                            {
                                name : "inventory_location_list",
                                label : "Inventory Location List",
                                type : "multiselect",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'inventory_location_list')) ? cvs.json_options.configuration.inventory_location_list  : "",
                                options : (cfo.inventoryLocations) ? cfo.inventoryLocations : [],
                                tooltip: 'Inventory locations',
                                tooltip_position: 'top',
                                hide: (this.getNestedProperty(cvs, 'json_options', 'configuration', 'use_inventory_location_list')) ? cvs.json_options.configuration.use_inventory_location_list !== 'true' : false
                            },
                            {
                                name : 'price_required_sync',
                                label : 'Price Required to Sync',
                                required : false,
                                type : 'select',
                                column : 'col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end',
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'price_required_sync')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Prevent any updates in the product if an active price is not set'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Allow updates to product even if there is no active price set'
                                    }
                                ],
                                tooltip: 'Will prevent any updates in the product if an active price is not set',
                                tooltip_position: 'top-no-label'
                            },
                            {
                                name : 'thumb_required_sync',
                                label : 'Thumbnail Required to Sync',
                                required : false,
                                type : 'select',
                                column : 'col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end',
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'thumb_required_sync')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Prevent any updates in the product if it doesnt have a thumbnail'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Allow updates to product even if it doesnt have a thumbnail'
                                    }
                                ],
                                tooltip: 'Will prevent any updates in the product if a thumbnail is not set',
                                tooltip_position: 'top-no-label'
                            },
                            {
                                name: 'push_children_as_single_products',
                                label: 'Push children as single products',
                                required: false,
                                type: 'select',
                                column: 'col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end',
                                value: (this.getNestedProperty(cvs, 'json_options', 'configuration', 'push_children_as_single_products')) ? 'true' : 'false',
                                options: [
                                    {
                                        'id': 'true',
                                        'name': 'Enabled - Push children as single products'
                                    },
                                    {
                                        'id': 'false',
                                        'name': 'Disabled - Do not push children as single products'
                                    }
                                ],
                                tooltip: 'Will push children as single products',
                                tooltip_position: 'top-no-label'
                            },
                            {
                                name: 'children_multiple_images',
                                label: 'Push Variant Images',
                                required: false,
                                type: 'select',
                                column: 'col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end',
                                value: (this.getNestedProperty(cvs, 'json_options', 'configuration', 'children_multiple_images')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Push all variant assets to the parent'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Push only the thumbnail to the parent'
                                    }
                                ],
                                hide: false
                            }

                        ]
                    },
                    {
                        groupingName : "Store in Metafields",
                        groupItems : [
                            {
                                name : "product",
                                label : "Products",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'product')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "variants",
                                label : "Variants",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'variants')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "variants_prices",
                                label : "Variants Prices",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'variants_prices')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "variants_with_attributes",
                                label : "Variants with Attributes",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'variants_with_attributes')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "variants_with_relations",
                                label : "Variants with Relations",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'variants_with_relations')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "relations",
                                label : "Relations",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'relations')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "relations_with_attributes",
                                label : "Relations with Attributes",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'relations_with_attributes')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            this.returnRelationsWithRelationAttributesGroupItem(cvs),
                            {
                                name : "generic_entities",
                                label : "Generic Entities",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'generic_entities')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "options",
                                label : "Options",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'options')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "prices",
                                label : "Prices",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'prices')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "inventory",
                                label : "Inventory",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'inventory')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "attributes",
                                label : "Attributes",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'attributes')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "barcodes",
                                label : "Barcodes",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'barcodes')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "brand",
                                label : "Brand",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'brand')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "parent",
                                label : "Parent",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'parent')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "tags",
                                label : "Tags",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'tags')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "assets",
                                label : "Assets",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'assets')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "future_exclusions",
                                label : "Future Exclusions",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'future_exclusions')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                        ]
                    }
                ];
            }
        },
        mounted() {
            this.setItems();
            this.channel.items = this.addCommonSettings(this.channel.items, this.channelvalues, this.channeloptions);
        },
    };
</script>
